import React from 'react';
import styled, { css, Palette, PaletteVariants, Sizes } from 'styled-components';
import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from '@material-ui/core/Checkbox';
import { Check, CheckboxIconProp } from '../Icons/Check';

export type CheckboxProps = {
  isInline?: boolean;
  checkboxSize?: Sizes;
  borderColor?: Palette;
  borderColorShade?: PaletteVariants;
} & MuiCheckboxProps &
  CheckboxIconProp;

const StyledCheckbox = styled(({ isInline, ...rest }) => <MuiCheckbox {...rest} />)<CheckboxProps>`
  ${(props) =>
    props.isInline &&
    css`
      && {
        margin-right: ${props.theme.sizes.xsmall};
        padding: 0 !important;
      }
    `}
`;

export const Checkbox: React.FC<CheckboxProps> = ({
  isInline,
  checkboxIconColor,
  checkboxSize = 'medium',
  borderColor = 'grey',
  borderColorShade = '500',
  ...props
}) => (
  <StyledCheckbox
    icon={
      <Check
        checkboxIconColor={checkboxIconColor}
        size={checkboxSize}
        borderColor={borderColor}
        borderColorShade={borderColorShade}
      />
    }
    checkedIcon={<Check checkboxIconColor={checkboxIconColor} checked size={checkboxSize} />}
    indeterminateIcon={
      <Check checkboxIconColor={checkboxIconColor} indeterminate size={checkboxSize} />
    }
    isInline
    {...props}
  />
);
